(function ($) {
    'use strict';

    Drupal.behaviors.fpiRmaCopyAddress = {
        attach: function (context, settings) {
            //count the number of items to display
            $(document).ready(function( $ ) {

                var $cb = $('<label />').html('Check if same as billing').prepend($('<input/>').attr({ type: 'checkbox', id: 'copyAddress'}));

                $('.group-shipping-info legend').once().append($cb);


                $('#copyAddress').click(function(){
                    var userLoc = window.location.href;
                    var userOs = navigator.platform;
                    var bCompanyName = '#edit-field-billing-company-name-und-0-value';
                    var bCompanyContact = '#edit-field-billing-contact-name-und-0-value';
                    var bCountry  = '#edit-field-billing-address-und-0-country';
                    var bThoroughfare = '#edit-field-billing-address-und-0-thoroughfare';
                    var bPremise = '#edit-field-billing-address-und-0-premise';
                    var bLocality = '#edit-field-billing-address-und-0-locality';
                    var bAdministrativeArea = '#edit-field-billing-address-und-0-administrative-area';
                    var bPostalCode  = '#edit-field-billing-address-und-0-postal-code';
                    var sCompanyName = '#edit-field-shipping-company-name-und-0-value';
                    var sCompanyContact = '#edit-field-shipping-contact-name-und-0-value';
                    var sCountry  = '#edit-field-shipping-address-und-0-country';
                    var sThoroughfare = '#edit-field-shipping-address-und-0-thoroughfare';
                    var sPremise = '#edit-field-shipping-address-und-0-premise';
                    var sLocality = '#edit-field-shipping-address-und-0-locality';
                    var sAdministrativeArea = '#edit-field-shipping-address-und-0-administrative-area';
                    var sPostalCode  = '#edit-field-shipping-address-und-0-postal-code';

                    if (this.checked) {

                        $(sCompanyName).val($(bCompanyName).val());
                        $(sCompanyContact).val($(bCompanyContact).val());
                        $(sCountry).val($(bCountry).val());
                        $(sThoroughfare).val($(bThoroughfare).val());
                        $(sPremise).val($(bPremise).val());
                        $(sLocality).val($(bLocality).val());
                        $(sAdministrativeArea).val($(bAdministrativeArea).val());
                        $(sPostalCode).val($(bPostalCode).val());

                    }
                })

            });


            // Don't delete these, they go to the top two lines
        }
    };




}(jQuery));
// console.log("fpi");
//# sourceMappingURL=maps/scripts.js.map
